// REACT
import { useEffect } from "react";

// MATERIAL UI
import { styled } from "@mui/material/styles";

// SHARED COMPONENTS
import { SwapCard } from "./components/SwapCard";

// AMPLITUDE
import { trackEvent } from "src/Amplitude";

const TradeWrapper = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "start",
}));

/**
 * The Swap component related to the Trade feature.
 * This component handles the swap functionality between two given assets and displays swap history.
 *
 * @returns {JSX.Element} - Swap component
 */
export const Swap = (): JSX.Element => {
  useEffect(() => {
    trackEvent("User visited Swap page", {}, "Swap");
  }, []);

  return (
    <TradeWrapper>
      <SwapCard />
    </TradeWrapper>
  );
};
